import { render } from "./IconOrder.vue?vue&type=template&id=fb433bdc"
import script from "./IconOrder.vue?vue&type=script&lang=js"
export * from "./IconOrder.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__